import React from 'react'
import PropTypes from 'prop-types'
import { Level, LevelLeft, LevelItem } from '../../bulma'
import { helpers } from '../../../helpers'

/**
* Header component for the `ProductSearchContainer`. Displays relevant info
* about the search container's current contents/state.
*/
function ProductSearchHeader(props) {
  const {
    current, total, filters, ...rest
  } = props

  // Display the search query if one is present.
  const keywordsLabel = filters.keywords ? (
    <LevelItem className="has-text-primary">
      <strong>for "{filters.keywords}"</strong>
    </LevelItem>
  ) : false

  return (
    <header {...rest} className="product-search-header">
      <Level>
        <LevelLeft>
          <LevelItem>
            Displaying {helpers.formatNumber(current)} of {helpers.formatNumber(total)} {total === 1 ? ' product' : ' products'}
          </LevelItem>
          {keywordsLabel}
        </LevelLeft>
      </Level>
    </header>
  )
}

ProductSearchHeader.defaultProps = {
  current: 0,
  total: 0,
  filters: {},
}

ProductSearchHeader.propTypes = {
  // Number of products currently being displayed.
  current: PropTypes.number,
  // Total number of products available.
  total: PropTypes.number,
  // Filters currently applied to search container.
  filters: PropTypes.object,
}

export default ProductSearchHeader
